import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-fb",
  "use": "foquz-icon-fb-usage",
  "viewBox": "0 0 13 20",
  "content": "<symbol viewBox=\"0 0 13 20\" fill=\"none\" id=\"foquz-icon-fb\"><path d=\"M11.268 1h-2.7a4.5 4.5 0 00-4.5 4.5v2.7h-2.7v3.6h2.7V19h3.6v-7.2h2.7l.9-3.6h-3.6V5.5a.9.9 0 01.9-.9h2.7V1z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol